import { useEffect } from 'react';

const BASE_URL = 'https://briljans.se';

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

// Sets per-page title, description, canonical and social tags.
// The prerender step snapshots the DOM after this has run, so every
// prerendered page ships correct head tags in its static HTML.
export default function Seo({ title, description, path = '/', noindex = false, image = null }) {
  useEffect(() => {
    document.title = title;
    const url = BASE_URL + path;
    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex, nofollow' : null);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'twitter:title', title);
    setMeta('property', 'twitter:description', description);
    setMeta('property', 'twitter:url', url);
    if (image) {
      setMeta('property', 'og:image', BASE_URL + image);
      setMeta('property', 'twitter:image', BASE_URL + image);
    }
    setCanonical(url);
  }, [title, description, path, noindex, image]);

  return null;
}
